import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"
import { ReactComponent as TableBaseIcon } from "src/v2/assets/icons/table-base-icon.svg"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { BoxDataCompany } from "../../components/box-data-company/box-data-company"
import { ADMIN_COMPANY_ACTIONS } from "./constants"

const CompanyTab = ({ companyData, isAdminUser }) => (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3, p: 3 }}>
        <BoxDataCompany companyData={companyData} />
        {isAdminUser && (
            <Box display="flex" flexWrap="wrap" gap={{ xxxs: 2, md: 3 }}>
                {ADMIN_COMPANY_ACTIONS.map((label) => (
                    <ButtonWithIcon key={label} icon={<TableBaseIcon />}>
                        {label}
                    </ButtonWithIcon>
                ))}
            </Box>
        )}
    </Box>
)

CompanyTab.propTypes = { companyData: PropTypes.object, isAdminUser: PropTypes.bool }

export default CompanyTab
